import { Moment } from 'moment';
import * as moment from 'moment';

export function isUndefined(variable: any): boolean{
    return typeof variable === 'undefined';
}
  
export function isNull(variable: any): boolean{
    return variable === null || variable === 'null';
}
  
export function isDefined(variable: any): boolean{
    return !isUndefined(variable) && !isNull(variable);
}
  
export function isDefinedSet(variable: any, defaultValue: any): any{
    return ((!isUndefined(variable) && !isNull(variable)) ? variable : defaultValue);
}
  
export function isEmpty(variable: any): boolean{
    return !isDefined(variable) || variable === '';
}

export function dateConvertTimezone(date: Date, timezone: string): string {
    const newDate = date.toLocaleString('en-US', {timeZone: timezone});

    return newDate;
}

export function objectToString(data: any): string {
    const parameters: any = {};

    for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
            if (data[key] !== null && typeof data[key] !== 'undefined' && data[key] !== '') {
                parameters[key] = data[key];
            }
        }
    }

    if (Object.keys(parameters).length > 0) {
        return '?' + Object.entries(parameters).map(([key, val]) => `${key}=${val}`).join('&');
    }

    return '';
}

export function dateFormat(date: string | Moment, format: string, originFormat: string = ''): string {
    if (date !== '' && date !== null && typeof date !== 'undefined') {
        if (originFormat !== '') {
            return moment(date, originFormat).format(format);
        }

        return moment(date).format(format);
    }

    return '';
}

export function isUUID(value: string): boolean {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidRegex.test(value);
}
